export const MEDIA_TYPE = {
  IMAGE: 'Image',
  VIDEO: 'Video',
  PDF: 'PDF',
  MS_WORD: 'MsWord',
  MS_EXCEL: 'MsExcel',
  CSV: 'Other',
  UNKNOWN: 'Unknown'
}

export const FILE_EXTENSION = {
  PNG: '.png',
  JPEG: '.jpeg',
  JPG: '.jpg',
  GIF: '.gif',
  MP4: '.mp4',
  PDF: '.pdf',
  DOC: '.doc',
  DOCX: '.docx',
  XLS: '.xls',
  XLSX: '.xlsx',
  CSV: '.csv'
}

export const MEDIA_TYPE_FORMATS = {
  [MEDIA_TYPE.IMAGE]: isOld => {
    if (isOld) {
      return [
        FILE_EXTENSION.JPEG,
        FILE_EXTENSION.JPG,
        FILE_EXTENSION.GIF,
        FILE_EXTENSION.PNG
      ]
    } else {
      return [FILE_EXTENSION.JPEG, FILE_EXTENSION.JPG, FILE_EXTENSION.GIF]
    }
  },
  [MEDIA_TYPE.VIDEO]: () => ['.mp4'],
  [MEDIA_TYPE.PDF]: () => [FILE_EXTENSION.PDF],
  [MEDIA_TYPE.MS_WORD]: () => [FILE_EXTENSION.DOC, FILE_EXTENSION.DOCX],
  [MEDIA_TYPE.MS_EXCEL]: () => [FILE_EXTENSION.XLS, FILE_EXTENSION.XLSX],
  [MEDIA_TYPE.CSV]: () => [FILE_EXTENSION.CSV]
}

export const MEDIA_ID_DATA_ATTRIBUTE = 'data-media-id'

export const MIME_TYPE = {
  IMAGE_JPEG: 'image/jpeg',
  IMAGE_PNG: 'image/png',
  IMAGE_GIF: 'image/gif',
  PDF: 'application/pdf',
  MS_WORD_DOC: 'application/msword',
  MS_WORD_DOCX:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  MS_EXCEL_XLS: 'application/vnd.ms-excel',
  MS_EXCEL_XLSX:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV: 'text/csv'
}

export const MIME_TYPES_BY_MEDIA_TYPE = {
  [MEDIA_TYPE.IMAGE]: [
    MIME_TYPE.IMAGE_JPEG,
    MIME_TYPE.IMAGE_PNG,
    MIME_TYPE.IMAGE_GIF
  ],
  [MEDIA_TYPE.PDF]: [MIME_TYPE.PDF],
  [MEDIA_TYPE.MS_WORD]: [MIME_TYPE.MS_WORD_DOC, MIME_TYPE.MS_WORD_DOCX],
  [MEDIA_TYPE.MS_EXCEL]: [MIME_TYPE.MS_EXCEL_XLS, MIME_TYPE.MS_EXCEL_XLSX],
  [MEDIA_TYPE.CSV]: [MIME_TYPE.CSV]
}

export const EXTENSIONS_BY_MIME_TYPE = {
  [MIME_TYPE.IMAGE_JPEG]: [FILE_EXTENSION.JPEG, FILE_EXTENSION.JPG],
  [MIME_TYPE.IMAGE_PNG]: [FILE_EXTENSION.PNG],
  [MIME_TYPE.PDF]: [FILE_EXTENSION.PDF],
  [MIME_TYPE.MS_WORD_DOC]: [FILE_EXTENSION.DOC],
  [MIME_TYPE.MS_WORD_DOCX]: [FILE_EXTENSION.DOCX],
  [MIME_TYPE.MS_EXCEL_XLS]: [FILE_EXTENSION.XLS],
  [MIME_TYPE.MS_EXCEL_XLSX]: [FILE_EXTENSION.XLSX],
  [MIME_TYPE.CSV]: [FILE_EXTENSION.CSV]
}

/**
 * MIME Types are used to identify file type from BLOB object (.type prop)
 * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Complete_list_of_MIME_types
 */

export const FILE_FIELD = {
  TITLE: 'TITLE',
  ALT_TEXT: 'ALT_TEXT',
  CAPTION: 'CAPTION'
}

export const MEDIA_ITEM_SOURCE = {
  MEDIA_ITEM_OBJECT: 'MEDIA_ITEM_OBJECT',
  BLOB: 'BLOB'
}

export const MAX_IMAGE_FILE_SIZE = 30 // 30Mb

export const MEDIA_VALIDATION = {
  FILE_FORMAT: 'FILE_FORMAT',
  MAX_FILE_SIZE: 'MAX_FILE_SIZE',
  REQUIRED_DIMENSIONS: 'REQUIRED_DIMENSIONS',
  PDF_WARNING: 'PDF_WARNING',
  FILE_DOWNLOAD: 'FILE_DOWNLOAD'
}
